import { useEffect } from 'react';
import { logScreenEventFromConfig } from 'services/analytics/segment/segment';
import {
  ActionType,
  useAnalyticsScreenKey,
} from 'shared/hooks/analytics/useAnalyticsScreenKey';

/**
 * Fires screen analytics events based on the current route.
 *
 * Uses Expo Router segments to derive a screen key, then looks up
 * the matching config entry and fires a Segment screen event.
 *
 * Place this component in a route group layout so events only fire
 * when the layout is rendered. For authenticated routes, render it
 * after the identity gate so userId is attached to every event.
 */
function ScreenAnalytics(): null {
  const screenKey = useAnalyticsScreenKey(ActionType.SCREEN);

  useEffect(() => {
    void logScreenEventFromConfig(screenKey, null);
  }, [screenKey]);

  return null;
}

export default ScreenAnalytics;
